if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        // Initialize magnify functionality for images in the modal
        this.initializeMagnify();
      }

      initializeMagnify() {
        if (window.enableZoomOnHover) {
          // Use requestAnimationFrame to ensure DOM is ready
          requestAnimationFrame(() => {
            setTimeout(() => {
              window.enableZoomOnHover(2, this);
            }, 200);
          });
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // Check if activeMedia is a deferred-media element
        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent) {
          // Check for any video type (YouTube, Vimeo, or regular video)
          const hasVideo = activeMediaContent.querySelector('.js-youtube, .js-vimeo, video');
          if (hasVideo) {
            activeMedia.loadContent();
          }
        } else {
          // Check for deferred-media inside the activeMedia container (for modal-media structure)
          const deferredMedia = activeMedia.querySelector('deferred-media');
          if (deferredMedia) {
            const deferredTemplate = deferredMedia.querySelector('template');
            const deferredContent = deferredTemplate ? deferredTemplate.content : null;
            if (deferredContent) {
              // Check for any video type (YouTube, Vimeo, or regular video)
              const hasVideo = deferredContent.querySelector('.js-youtube, .js-vimeo, video');
              if (hasVideo) {
                deferredMedia.loadContent();
              }
            }
          }
        }
        
        // Initialize magnify for the active media after it's shown
        if (window.enableZoomOnHover && activeMedia) {
          requestAnimationFrame(() => {
            setTimeout(() => {
              window.enableZoomOnHover(2, activeMedia);
            }, 150);
          });
        }
      }
    }
  );
  
}
